
<div>
  <template v-if="loading">
    <slot name="loading">{{ loadingText }}</slot>
  </template>
  <template v-else-if="failed">
    <slot name="failed">{{ failedText }}</slot>
  </template>
  <slot v-else>
    <slot name="loaded"></slot>
  </slot>
</div>
